const hemData = [
  {
    start: 0,
    end: 25000,
    single: 1311,
    joint: 2543,
  },
  {
    start: 25001,
    end: 38000,
    single: 1374,
    joint: 2543,
  },
  {
    start: 38001,
    end: 51000,
    single: 1446,
    joint: 2615,
  },
  {
    start: 51001,
    end: 64000,
    single: 1550,
    joint: 2720,
  },
  {
    start: 64001,
    end: 76000,
    single: 1728,
    joint: 2899,
  },
  {
    start: 76001,
    end: 102000,
    single: 2002,
    joint: 3175,
  },
  {
    start: 102001,
    end: 127000,
    single: 2343,
    joint: 3518,
  },
  {
    start: 127001,
    end: 153000,
    single: 2661,
    joint: 3837,
  },
  {
    start: 153001,
    end: 178000,
    single: 3015,
    joint: 4194,
  },
  {
    start: 178001,
    end: 204000,
    single: 3200,
    joint: 4379,
  },
  {
    start: 204001,
    end: 254000,
    single: 3470,
    joint: 4651,
  },
  {
    start: 254001,
    end: 318000,
    single: 4002,
    joint: 5187,
  },
  {
    start: 318001,
    end: 382000,
    single: 4634,
    joint: 5822,
  },
  {
    start: 382001,
    end: 636000,
    single: 4795,
    joint: 5984,
  },
];

const HemSingleJoint = (totalIncome, numberOfApplicants) => {
  const dataIndex = hemData.findIndex(
    (p) => totalIncome >= p.start && totalIncome < p.end
  );

  if (dataIndex === -1) {
    return hemData[11].single;
  }

  switch (Number(numberOfApplicants)) {
    case 1:
      return hemData[dataIndex].single;
    case 2:
      return hemData[dataIndex].joint;
    default:
      return hemData[dataIndex].single;
  }
};

export default HemSingleJoint;
